export const workouts = [
  {
    id: "1",
    userId: "11",
    dayId: "1",
    programId: "1",
    hasNote: false,
    workoutName: "Dumbbell Squeeze Press",
    category: "Chest",
    numberOfSets: 3,
    sets: [
      { weightUnit: "kg", reps: 12, weight: 20 },
      { weightUnit: "kg", reps: 10, weight: 22 },
      { weightUnit: "kg", reps: 8, weight: 24 },
    ],
    totalNumberOfWeight: 66,
    totalNumberOfReps: 30,
    progressState: 0,
    isSpecialWorkout: false,
    superSet: {},
    dropSet: {},
    createdAt: new Date(),
  },
  {
    id: "2",
    userId: "22",
    dayId: "3",
    programId: "2",
    hasNote: true,
    workoutName: "Wide lats pull down",
    category: "Back",
    numberOfSets: 4,
    sets: [
      { weightUnit: "kg", reps: 20, weight: 10 },
      { weightUnit: "kg", reps: 14, weight: 20 },
      { weightUnit: "kg", reps: 10, weight: 40 },
      { weightUnit: "kg", reps: 8, weight: 60 },
    ],
    totalNumberOfWeight: 110,
    totalNumberOfReps: 52,
    progressState: 0,
    isSpecialWorkout: true,
    superSet: {},
    dropSet: {
      numberOfSets: 3,
      sets: [
        { weightUnit: "kg", reps: 10, weight: 12 },
        { weightUnit: "kg", reps: 8, weight: 12 },
        { weightUnit: "kg", reps: 7, weight: 14 },
      ],
      totalNumberOfWeight: 38,
      totalNumberOfReps: 25,
    },
    createdAt: new Date(),
  },
  {
    id: "3",
    userId: "33",
    dayId: "3",
    programId: "3",
    hasNote: true,
    workoutName: "Cable fly",
    category: "Chest",
    numberOfSets: 4,
    sets: [
      { weightUnit: "kg", reps: 15, weight: 35 },
      { weightUnit: "kg", reps: 12, weight: 40 },
      { weightUnit: "kg", reps: 10, weight: 45 },
      { weightUnit: "kg", reps: 10, weight: 50 },
    ],
    totalNumberOfWeight: 170,
    totalNumberOfReps: 47,
    progressState: 2,
    isSpecialWorkout: false,
    superSet: {},
    dropSet: {},
    createdAt: new Date(),
  },
  {
    id: "4",
    userId: "44",
    dayId: "4",
    programId: "4",
    hasNote: false,
    workoutName: "Shoulder press",
    category: "Shoulders",
    numberOfSets: 3,
    sets: [
      { weightUnit: "lbs", reps: 12, weight: 20 },
      { weightUnit: "lbs", reps: 8, weight: 25 },
      { weightUnit: "lbs", reps: 6, weight: 30 },
    ],
    totalNumberOfWeight: 75,
    totalNumberOfReps: 26,
    progressState: 1,
    isSpecialWorkout: true,
    superSet: {
      workoutName: "Rafrafa Ganbe",
      numberOfSets: 3,
      sets: [
        { weightUnit: "lbs", reps: 10, weight: 12 },
        { weightUnit: "lbs", reps: 8, weight: 12 },
        { weightUnit: "lbs", reps: 7, weight: 14 },
      ],
      totalNumberOfWeight: 38,
      totalNumberOfReps: 25,
    },
    dropSet: {},
    createdAt: new Date(),
  },
];
